import { Grid, Typography } from '@mui/material';
import NoProject from 'assets/NoProject.svg';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getMaintenanceStatus } from 'services/admin-users';

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {data, isLoading} = useQuery({
    queryKey: ['maintenance'],
    queryFn: () => getMaintenanceStatus()
    })


    useEffect(() => {
        if(data?.maintenanceMode == false) {
            navigate('/')
        }
    }, [data])


  return (
     <Grid container spacing={2} justifyContent="center" alignItems="center" width="100%" height="100%" flexDirection="column" >
    <Grid item xs={12} width="100%" height="100%" mt={10} justifyContent="center" alignItems="center">
    <Typography align="center" variant="h1" component="h1" gutterBottom>
      {t('MAINTENANCE_TITLE')}
    </Typography>
    </Grid>
    
    <Grid item xs={12} width="50%" height="50%" mt={2}>
   
      <img src={NoProject} style={{ width: '100%', height: '100%' }} alt="No Project" />
    </Grid>
    <Grid item xs={12} mt={2} >
  
    <Typography variant="h2">
      {t('MAINTENANCE_MESSAGE')}
    </Typography>
    </Grid>
  </Grid>
  );
};

export default MaintenancePage; 